import classNames from 'classnames'
import { slashTermsURL } from '../../libs/constants'
import CheckBox from '../babu/CheckBox'

export default function AgreeTermsCard(props: {
  agreed: boolean
  setAgreed: (value: boolean) => void
  cardClassName?: string
}) {
  const { agreed } = props
  return (
    <div className={classNames('babu-card py-0', props.cardClassName)}>
      <CheckBox
        checked={agreed}
        label={
          <span className="babu-text ml-xs">
            {'同意 '}
            <a
              href={slashTermsURL}
              target="_blank"
              rel="noopener noreferrer"
              className="underline">
              aifian 服務條款
            </a>
          </span>
        }
        labelProps={{
          className: 'py-l w-full',
        }}
        onChange={() => props.setAgreed(!agreed)}
      />
    </div>
  )
}
